// extracted by mini-css-extract-plugin
module.exports = {"password-reset-form__code-section":"GetPassword_password-reset-form__code-section__3rrw3","password-reset-form":"GetPassword_password-reset-form__Q9Lxd"};